import { DIALER_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'outboundAbandonmentRate',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Outbound Abandonment',
    sort: 'ascending',
  },
}

const keys = {
  componentKeys: [DIALER_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'outbound_abandoned' },
  divisor: { stat: 'calls' },
  isRate: true,
}

const outboundAbandonmentRate = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { outboundAbandonmentRate }
